/** @jsxImportSource @emotion/react */
import React, { ReactNode } from 'react';
import t from '../../theme/styles';
import { ProjectSection } from './ProjectSection';

export function ProjectOverview(props: { children?: ReactNode }) {
    return <ProjectSection style={[t.mt('180px'), t.md([t.mt_0, t.mr('260px')])]}>{props.children}</ProjectSection>;
}
